import CollectionContent from "./collection-content.jsx";
import { h, render } from "preact";

class SectionMainCollection extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.mainCollection = this.querySelector("[data-main-collection]");
    this.init();
  }

  init() {
    const MainCollection = () => {
      return <CollectionContent data={this.data} />;
    };

    render(<MainCollection />, this.mainCollection);
  }
}

if (!customElements.get("section-main-collection")) {
  customElements.define("section-main-collection", SectionMainCollection);
}
